import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class GMPPrintService {
  printoutGenerationInProgress = new BehaviorSubject<boolean>(false);
}
